/** Relative time label — matches bag-tag-prototype-updated.html */
export function timeAgo(iso: string): string {
  const t = new Date(iso).getTime();
  const d = Math.floor((Date.now() - t) / 1000);
  if (d < 60) return `${d}s`;
  if (d < 3600) return `${Math.floor(d / 60)}m`;
  if (d < 86400) return `${Math.floor(d / 3600)}h`;
  if (d < 604800) return `${Math.floor(d / 86400)}d`;
  return `${Math.floor(d / 604800)}w`;
}
